





























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ChoiceEdit from '@/components/ChoiceEdit.vue';
import {IEditChoice, IEditOption} from '@/components/ItemEdit.vue';
import { isEqual } from 'lodash';
import {WebService} from '@/services/web.service';
import {Helpers} from '@/services/helpers.service';
// @ is an alias to /src


@Component({
	components: {
		'choice-edit': ChoiceEdit
	}
})
export default class OptionEdit extends Vue {
	@Prop({required: true})
	menuId!: string;

	@Prop({required: true})
	itemId!: string | null;

	@Prop({required: true})
	option!: IEditOption;

	@Prop({required: true})
	index!: number;

	@Prop({required: true})
	count!: number;

	@Prop({required: true})
	hasUnsaved!: boolean;

	private optionName = '';
	private choices: IEditChoice[] = [];
	private minChoices = 0;
	private maxChoices = 0;
	// private required = false;
	private priority = 0;
	private ignoreChanges = false;
	private lastUpdatedIndex = -1;

	showLoading = false;

	loadingOverlays: {[key: string]: boolean} = {
		position: false,
		name: false,
		minChoices: false,
		maxChoices: false
	};

	created() {
		if(this.option.optionId === null) {
			this.addChoice();
		}
	}

	setupOption() {
		this.ignoreChanges = true;
		this.optionName = this.option.name;
		this.minChoices = this.option.minChoices;
		this.maxChoices = this.option.maxChoices;
		this.choices = this.option.choices;
		this.priority = this.option.priority;
		this.ignoreChanges = false;
	}

	@Watch('option', {immediate: true})
	onOptionChange() {
		this.setupOption();
	}

	addChoice() {
		this.choices.push({
			choiceId: null,
			name: '',
			price: 0,
			selected: false
		});
	}

	async deleteOption() {
		if(this.option.optionId === null) {
			this.$emit('deleteOption');
		} else {
			if(await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this modifier?', {
				centered: true,
				okTitle: 'Delete Modifier'
			})) {
				if(this.itemId !== null) {
					try {
						this.showLoading = true;
						await WebService.removeOptionFromItem(this.menuId, this.itemId, this.option.optionId);
						this.showLoading = false;
					} catch(e) {
						this.showLoading = false;
						await this.$bvModal.msgBoxOk('There was a problem deleting your modifier', {
							title: 'Error',
							centered: true,
							okTitle: 'Ok'
						});
					}
				}
			}
		}

	}

	get isDirty() {
		return !isEqual(this.cleanServerOption, this.cleanOption) ||
			(this.cleanOption.optionId === null && this.canSave);
	}

	get cleanOption() {
		return {
			optionId: this.option.optionId,
			name: this.optionName.trim(),
			maxChoices: this.maxChoices,
			minChoices: this.minChoices,
			priority: this.priority
		};
	}

	get cleanServerOption() {
		return {
			optionId: this.option.optionId,
			name: this.option.name.trim(),
			maxChoices: this.option.maxChoices,
			minChoices: this.option.minChoices,
			priority: this.option.priority
		};
	}

	get canSave() {
		return this.optionName.trim() !== '';
	}

	get hasUnsavedChoices() {
		return this.choices.reduce((bool, choice) => {
			if(choice.choiceId === null) {
				return true;
			}
			return bool;
		}, false);
	}

	deleteChoice(index: number) {
		this.choices.splice(index, 1);
	}

	get selectedChoices() {
		return this.choices.reduce((selected: number[], choice, index) => {
			if(choice.selected) {
				selected.push(index);
			}
			return selected;
		}, []);
	}

	fixSelections() {

		console.log('fixing selection');
		if(this.maxChoices === 1) {
			let seenMaxSelected = false;
			if(this.lastUpdatedIndex !== -1 && this.choices[this.lastUpdatedIndex].selected) {
				seenMaxSelected = true;
			} else {
				this.lastUpdatedIndex = -1;
			}
			for(const index in this.choices) {
				if(this.choices[index].selected && seenMaxSelected && Number(index) !== this.lastUpdatedIndex) {
					this.choices[index].selected = false;
				} else if(this.choices[index].selected) {
					seenMaxSelected = true;
				}
			}
		} else if(this.maxChoices !== 0) {
			const selected = this.selectedChoices;
			if(selected.length > this.maxChoices) {
				// If we just selected a new one let's start but un-selecting that
				const indexOfRecentSelectedPick = selected.indexOf(this.lastUpdatedIndex);
				if(indexOfRecentSelectedPick !== -1) {
					this.choices[this.lastUpdatedIndex].selected = false;
					selected.splice(indexOfRecentSelectedPick, 1);
				}
				// If we still have too many then just cut off the extras
				if(selected.length > this.maxChoices) {
					selected.slice(this.maxChoices).forEach((index) => {
						this.choices[index].selected = false;
					});
				}
			}
		}
		this.lastUpdatedIndex = -1;
	}

	updateChoice(index: number, choice: IEditChoice) {
		this.lastUpdatedIndex = index;
		Vue.set(this.choices, index, choice);
	}

	@Watch('choices', {deep: true})
	onUpdates() {
		this.fixSelections();
	}

	async saveOption() {
		if(
			!this.ignoreChanges &&
			this.isDirty &&
			this.canSave
		) {
			console.log('Saving Option');
			if(this.option.optionId === null) {
				await this.createOption();
			} else {
				const diff = Helpers.diff(this.cleanOption, this.cleanServerOption);
				const fieldsBeingUpdated = [];
				for(const key in diff) {
					if(key in this.loadingOverlays) {
						fieldsBeingUpdated.push(key);
					}
				}

				await this.updateOption(fieldsBeingUpdated);

				// alert('Not Implemented');
			}
		}
		this.updateParent();
	}

	async createOption() {
		let errorMessage = 'There was a problem creating your modifier';
		if(this.itemId !== null) {
			try {
				this.loadingOverlays.name = true;
				const optionId = await WebService.createOption({
					name: this.optionName,
					minChoices: this.minChoices,
					maxChoices: this.maxChoices,
					priority: this.priority,
					// categoryId: this.categoryId
				});
				errorMessage = 'There was a problem adding your modifier to the item';
				await WebService.addOptionToItem(this.menuId, this.itemId, optionId);
				this.loadingOverlays.name = false;
			} catch(e) {
				this.loadingOverlays.name = false;
				await this.$bvModal.msgBoxOk(errorMessage, {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}
	}

	async updateOption(fieldsBeingUpdated: string[]) {
		try {
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = true;
			});
			if(this.option.optionId !== null) {
				await WebService.updateOption(this.menuId, {
					optionId: this.option.optionId,
					name: this.optionName,
					minChoices: this.minChoices,
					maxChoices: this.maxChoices,
					priority: this.priority,
				});
			}
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = false;
			});
			// this.$emit('update:itemId', itemId);
		} catch(e) {
			fieldsBeingUpdated.forEach((key) => {
				this.loadingOverlays[key] = false;
			});
			await this.$bvModal.msgBoxOk('There was a problem updating your option', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}


	updateParent(optionId: string | null = null) {
		if(!this.ignoreChanges) {
			// Check if we need to save before we do anything
			this.$emit('update:option', {
				optionId: optionId === null ? this.option.optionId : optionId,
				name: this.optionName,
				priority: this.priority,
				maxChoices: this.maxChoices,
				minChoices: this.minChoices,
				choices: this.choices
			});
		}
	}

}
